class TreasureShow{
    constructor ($http, $scope, $interval) {
        this.$http = $http;
        this.$scope = $scope;
        this.$interval = $interval;
        this.money = [];
        this.items = [];
    }

    select(item)
    {
        this.selected = item;
    }

    keepalive()
    {
        this.$http(
            {
                url: "/treasure/keepalive/" + this.id,
                method: "get"
            }
        ).then((resp) => {
            if(this.subdata.date!=resp.data.time)
                this.load(this.id);
        }, (err) => {
            console.log(err);
        });
    }

    load(id)
    {
        this.$http(
            {
                url: "/treasure/getchest/" + id,
                method: "get"
            }
        ).then((resp) => {
            if(!resp.data.error)
            {
                this.$interval(()=>{this.keepalive();}, 10000);
                this.id = id;
                this.subdata = resp.data.subdata;
                this.items = resp.data.items;
                this.money = resp.data.money;
            }
        }, (err) => {
            console.log(err);
        });
    }

}

TreasureShow.$inject = ['$http', '$scope', '$interval'];

export {TreasureShow};